import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
import { environment } from '../../../../../environments/environment';

const env = environment;

@Component({
  selector: 'app-paso-uno-login',
  templateUrl: './paso-uno-login.component.html',
  styleUrls: ['./paso-uno-login.component.scss']
})
export class PasoUnoLoginComponent implements OnInit {
  isRetoma: boolean;
  validacionCheck = false;
  validacion: any;
  rutEmpresaValido = false;
  irPaso2 = false;
  personType='personaNatural';
  personTypes ={personaNatural:'persona',personaJuridica:'empresa'};
  utm?="";
  

  get created() {return this.flujos.paso1Created; }

  /* Validacion de inputs */
  public dataPasoUno: FormGroup = new FormGroup({
    seleccionFlujo: new FormControl('personaNatural', [Validators.required]),
    autorizacion: new FormControl('', [Validators.requiredTrue])
  });

  @Output() nextStep: EventEmitter<any> = new EventEmitter();
  seleccionFlujo: any;

  constructor(
    private flujos: FlujosPaso2Service,
    private stepperService: StepperServiceVM,
    private carroService: CarroComprasService,
    private route: ActivatedRoute,
    private tagM:TagManagerService,
    private storage: LocalStorageService,

    ) {
  }

  ngOnInit() {
    if (window.innerWidth < 1200) {
      this.carroService.hide();
    }
    this.utm = this.route.snapshot.queryParams.utm;
    this.storage.setPaso0({utm: this.utm});

    /* TODO: Checar si aplica eliminar el retoma en todos los casos */
    /*this.route.queryParams
      .subscribe(params => {
        this.isRetoma = params.action == AUTH_INDICATOR.IS_RETOMA;
      }
    );*/

   if (this.route.snapshot.queryParams.utm != null && this.route.snapshot.queryParams.utm ==  environment.marcaGa4DesdeMarkectplace ) {
    setTimeout(() => {
      this.tagM.logEvent (GoogleTagManager.eventAddToCart().setOrigen(this.utm));
    }, 1000);
   }

    
    this.tagM.logEvent (GoogleTagManager.eventPageView().comoQuieresVender());
  }

  onNextStep(): void {
    this.nextStep.emit();

  }

  fixForm() {
    this.dataPasoUno.get('seleccionFlujo').setValue('personaJuridica');
  }

  public getRetomar() {
    return this.carroService.getRetoma();
  }

  radioChangePersonType():void{
     const accionGTM = GoogleTagManager.eventInteracciones().categriaComoVender(this.personTypes[this.personType]);
      this.tagM.logEvent( accionGTM.accionClick());
  }
}
